import dashboardsReducer from "./reducers";
export { default as dashboardsTypes } from "./types";
export { default as dashboardsOperations } from "./operations";
export default dashboardsReducer;
